import React from 'react';
import DragDropContextProvider from '../DragDropContextProvider';
export default Component => {
    const withDNDContext = props => (React.createElement(DragDropContextProvider, null,
        React.createElement(Component, { ...props })));
    withDNDContext.displayName = Component.displayName;
    return withDNDContext;
};
//# sourceMappingURL=withDNDContext.js.map